/* eslint max-len: [0] */
export const JAWS_SET_INSTANCE = 'JAWS_SET_INSTANCE';
export const JAWS_CONNECTION_ESTABLISHED = 'JAWS_CONNECTION_ESTABLISHED';
export const JAWS_CONNECTION_CLOSED = 'JAWS_CONNECTION_CLOSED';

export const ADD_ITEM = 'ADD_ITEM';
export const ADD_ITEMS = 'ADD_ITEMS';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const DELETE_ALL_ITEMS = 'DELETE_ALL_ITEMS';
export const COMPONENT_INITIALIZED = 'COMPONENT_INITIALIZED';
export const SET_COMPONENT_TOTAL_SIZE = 'SET_COMPONENT_TOTAL_SIZE';

export const ADD_COMPONENT = 'ADD_COMPONENT';
export const DELETE_COMPONENT = 'DELETE_COMPONENT';

export const REQUEST_USER_INFO = 'REQUEST_USER_INFO';
export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO';
export const LOGOUT_USER = 'LOGOUT_USER';
export const USER_INFO_SET_BALANCE = 'USER_INFO_SET_BALANCE';
export const USER_INFO_SET_MARGIN = 'USER_INFO_SET_MARGIN';
export const USER_SET_SELECTED_ACCOUNT = 'USER_SET_SELECTED_ACCOUNT';

export const REQUEST_SNIPLETS = 'REQUEST_SNIPLETS';
export const RECEIVE_SNIPLETS = 'RECEIVE_SNIPLETS';
export const UPDATE_SNIPLET = 'UPDATE_SNIPLET';

export const GRAPHDATA_REQUEST_BUCKET = 'GRAPHDATA_REQUEST_BUCKET';
export const GRAPHDATA_RECEIVE_BUCKET = 'GRAPHDATA_RECEIVE_BUCKET';
export const GRAPHDATA_SET_ITEM = 'GRAPHDATA_SET_ITEM';
export const GRAPHDATA_SET_SELECTION = 'GRAPHDATA_SET_SELECTION';
export const GRAPHDATA_SETUP_COMPONENT = 'GRAPHDATA_SETUP_COMPONENT';
export const GRAPHDATA_RECEIVE_SERIES = 'GRAPHDATA_RECEIVE_SERIES';
export const GRAPHDATA_CREATE_BUCKET = 'GRAPHDATA_CREATE_BUCKET';
export const GRAPHDATA_REQUEST_DATA = 'GRAPHDATA_REQUEST_DATA';
export const GRAPHDATA_CLEAR_BUCKETS = 'GRAPHDATA_CLEAR_BUCKETS';
export const GRAPHDATA_ADD_BUCKET_WITH_SERIES =
  'GRAPHDATA_ADD_BUCKET_WITH_SERIES';

export const OVERVIEW_CHART_REQUEST_DATA = 'OVERVIEW_CHART_REQUEST_DATA';
export const OVERVIEW_CHART_RECEIVE_DATA = 'OVERVIEW_CHART_RECEIVE_DATA';
export const OVERVIEW_CHART_SET_PERIOD = 'OVERVIEW_CHART_SET_PERIOD';
export const OVERVIEW_CHART_SET_ITEM = 'OVERVIEW_CHART_SET_ITEM';
export const OVERVIEW_CHART_OPTIMISTICALLY_ADD_ITEM =
  'OVERVIEW_CHART_OPTIMISTICALLY_ADD_ITEM';

export const ANALYSIS_CHART_SET_MAIN_INSTRUMENT =
  'ANALYSIS_CHART_SET_MAIN_INSTRUMENT';
export const ANALYSIS_CHART_RECEIVE_GRAPHDATA =
  'ANALYSIS_CHART_RECEIVE_GRAPHDATA';
export const ANALYSIS_CHART_RECEIVE_GRAPHDATA_MAIN =
  'ANALYSIS_CHART_RECEIVE_GRAPHDATA_MAIN';
export const ANALYSIS_CHART_ADD_COMPARE = 'ANALYSIS_CHART_ADD_COMPARE';
export const ANALYSIS_CHART_REMOVE_COMPARE = 'ANALYSIS_CHART_REMOVE_COMPARE';
export const ANALYSIS_CHART_SET_SELECTION = 'ANALYSIS_CHART_SET_SELECTION';
export const ANALYSIS_CHART_INVALIDATE_ALL = 'ANALYSIS_CHART_INVALIDATE_ALL';
export const ANALYSIS_CHART_TOGGLE_ADDITION = 'ANALYSIS_CHART_TOGGLE_ADDITION';
export const ANALYSIS_CHART_RECEIVE_ADDITION =
  'ANALYSIS_CHART_RECEIVE_ADDITION';
export const ANALYSIS_CHART_REMOVE_ADDITION = 'ANALYSIS_CHART_REMOVE_ADDITION';
export const ANALYSIS_CHART_REQUEST_DATA = 'ANALYSIS_CHART_REQUEST_DATA';
export const ANALYSIS_CHART_ADD_TECHNICAL_INDICATOR =
  'ANALYSIS_CHART_ADD_TECHNICAL_INDICATOR';
export const ANALYSIS_CHART_REMOVE_TECHNICAL_INDICATOR =
  'ANALYSIS_CHART_REMOVE_TECHNICAL_INDICATOR';
export const ANALYSIS_CHART_REMOVE_ALL_TECHNICAL_INDICATORS =
  'ANALYSIS_CHART_REMOVE_ALL_TECHNICAL_INDICATORS';

// Not yet implemented
// export const OVERVIEW_CHART_ADD_ITEM = 'OVERVIEW_CHART_ADD_ITEM';
// export const OVERVIEW_CHART_DELETE_ITEM = 'OVERVIEW_CHART_DELETE_ITEM';
// export const OVERVIEW_CHART_ADD_ITEM = 'OVERVIEW_CHART_ADD_ITEM';
// export const OVERVIEW_CHART_REORDER_ITEMS = 'OVERVIEW_CHART_REORDER_ITEMS';

export const INSTRUMENT_REQUEST_DATA = 'INSTRUMENT_REQUEST_DATA';
export const INSTRUMENT_RECEIVE_DATA = 'INSTRUMENT_RECEIVE_DATA';

export const SPARKLINE_REQUEST_DATA = 'SPARKLINE_REQUEST_DATA';
export const SPARKLINE_RECEIVE_DATA = 'SPARKLINE_RECEIVE_DATA';
export const SPARKLINE_CREATE = 'SPARKLINE_CREATE';

export const SUGGEST_REQUEST_DATA = 'SUGGEST_REQUEST_DATA';
export const SUGGEST_RECEIVE_DATA = 'SUGGEST_RECEIVE_DATA';
export const SUGGEST_SET_ANCHOR = 'SUGGEST_SET_ANCHOR';
export const SUGGEST_SET_SELECTED_INDEX = 'SUGGEST_SET_SELECTED_INDEX';
export const SUGGEST_SET_INDICATOR_INDEX = 'SUGGEST_SET_INDICATOR_INDEX';
export const SUGGEST_CLOSE_AND_RESET = 'SUGGEST_CLOSE_AND_RESET';

export const INVALIDATE_WATCHLISTS = 'INVALIDATE_WATCHLISTS';
export const REQUEST_WATCHLISTS = 'REQUEST_WATCHLISTS';
export const RECEIVE_WATCHLISTS = 'RECEIVE_WATCHLISTS';
export const WATCHLIST_ADD_ITEM = 'WATCHLIST_ADD_ITEM';
export const WATCHLIST_DELETE_ITEM = 'WATCHLIST_DELETE_ITEM';
export const WATCHLIST_ADD_LIST = 'WATCHLIST_ADD_LIST';
export const WATCHLIST_DELETE_LIST = 'WATCHLIST_DELETE_LIST';
export const WATCHLIST_UPDATE_LIST = 'WATCHLIST_UPDATE_LIST';
export const SET_SELECTED_WATCHLIST = 'SET_SELECTED_WATCHLIST';

export const ADMIN_USERS_REQUEST_DATA = 'ADMIN_USERS_REQUEST_DATA';
export const ADMIN_USERS_RECEIVE_DATA = 'ADMIN_USERS_RECEIVE_DATA';

export const ADMIN_CUSTOMERS_REQUEST_DATA = 'ADMIN_CUSTOMERS_REQUEST_DATA';
export const ADMIN_CUSTOMERS_RECEIVE_DATA = 'ADMIN_CUSTOMERS_RECEIVE_DATA';

export const ADMIN_AUDIT_REQUEST_DATA = 'ADMIN_AUDIT_REQUEST_DATA';
export const ADMIN_AUDIT_RECEIVE_DATA = 'ADMIN_AUDIT_RECEIVE_DATA';

export const REPORTS_REQUEST_DATA = 'REPORTS_REQUEST_DATA';
export const REPORTS_RECEIVE_DATA = 'REPORTS_RECEIVE_DATA';

export const ORDERS_REQUEST_DATA = 'ORDERS_REQUEST_DATA';
export const ORDERS_RECEIVE_DATA = 'ORDERS_RECEIVE_DATA';

export const ALERTS_REQUEST_DATA = 'ALERTS_REQUEST_DATA';
export const ALERTS_RECEIVE_DATA = 'ALERTS_RECEIVE_DATA';
export const ALERTS_UPDATE_ALERT = 'ALERTS_UPDATE_ALERT';
export const ALERTS_REMOVE_ALERT = 'ALERTS_REMOVE_ALERT';

export const FICTIVE_PORTFOLIOS_REQUEST_DATA =
  'FICTIVE_PORTFOLIOS_REQUEST_DATA';
export const FICTIVE_PORTFOLIOS_RECEIVE_DATA =
  'FICTIVE_PORTFOLIOS_RECEIVE_DATA';
